import { UUID } from "../../utils/typeDefinitions";
import Document from "./Document";
import IContextDocument from "./IContextDocument";

export default abstract class ProjectDocument implements IContextDocument {
    projectUuid: UUID;
    document: Document;
    version: number;

    constructor(projectId: UUID, document: Document, version: number) {
        this.projectUuid = projectId;
        this.document = document;
        this.version = version;
    }

    toJson(): any {
        return {
            projectId: this.projectUuid,
            version: this.version,
            document: this.document.toJson()
        };
    }

    abstract getEntityId(): UUID;
}
